import { createFileRoute } from '@tanstack/react-router'
import { UserEditForm } from '@/components/user-edit-form'
import { requireAuth } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/user/edit')({
  beforeLoad: requireAuth,
  component: UserEditPage,
})

function UserEditPage() {
  return (
    <div className="container mx-auto p-4">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Profil Düzenle</h1>
          <p className="text-gray-600 mt-1">Profil bilgilerinizi güncelleyin</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <UserEditForm />
        </div>
      </div>
    </div>
  )
}